module.exports = __webpack_public_path__ + "img/pocket_width_welt.ae8e0ccd.png";